import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.trim.js";
// 手机号码
// eslint-disable-next-line no-useless-escape
export var isMobile = function isMobile(str) {
  return /^[0-9\+\-\(\)]{9,20}$/.test(str);
};

// 是否是 数字
export var isNumber = function isNumber(val) {
  var regPos = /^\d+(\.\d+)?$/; // 非负浮点数
  var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; // 负浮点数
  return !!(regPos.test(val) || regNeg.test(val));
};

// 是否是 银行卡号
export var isAccountNo = function isAccountNo(val) {
  return /^[0-9]{8,12}$/.test(val);
};

// ID规则
export var isIdentity = function isIdentity(val) {
  return /(^(?![^A-Z]+$)(?!\D+$)[A-Z0-9]{8,9}$)|(^[0-9]{10}$)/;
};

/**
 * @description 判断是否是有效链接
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @description 判断用户
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  var validMap = ['admin', 'editor'];
  return validMap.indexOf(str.trim()) >= 0;
}